import { Check, Ban } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { Section, Loadable, Empty, Status, ActionButton, useLoad, fmt, label } from "@/components/control/kit";

function RequestRow({ r, reload, t }) {
  const confirmed = r.status === "wartezeit";
  return (
    <li className="flex flex-wrap items-start justify-between gap-2 py-3" data-testid={`recovery-request-${r.id}`}>
      <div className="min-w-0 flex-1 basis-full sm:basis-auto">
        <p className="break-words font-medium text-brand-purple">{r.name} · {r.email} · {label(r.role)}</p>
        <p className="text-xs text-muted-foreground">
          {t("login.mail_recovery.admin_meta", { created: fmt(r.created_at), confirmed: fmt(r.confirmed_at), wait: fmt(r.wait_until) })}
        </p>
        {!confirmed && <p className="text-xs text-orange-800" data-testid={`recovery-request-wait-email-${r.id}`}>{t("login.mail_recovery.admin_wait_email")}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Status value={r.approved ? "freigegeben" : r.status} testId={`recovery-request-status-${r.id}`} />
        {!r.approved && (
          <ActionButton label={t("login.mail_recovery.admin_approve")} icon={Check} testId={`approve-recovery-${r.id}`} onDone={reload}
            disabled={!confirmed} danger submitLabel={t("login.mail_recovery.admin_approve")}
            description={t("login.mail_recovery.admin_approve_info")}
            fields={[{ name: "confirm_email", label: t("login.mail_recovery.admin_confirm_email", { email: r.email }), required: true },
              { name: "reason", label: t("login.mail_recovery.admin_reason"), type: "textarea", required: true }]}
            onSubmit={async (v) => { await api.post(`/team/2fa-recovery-requests/${r.id}/approve`, v); return t("login.mail_recovery.admin_approved"); }} />
        )}
        <ActionButton label={t("login.mail_recovery.admin_reject")} icon={Ban} testId={`reject-recovery-${r.id}`} onDone={reload}
          danger submitLabel={t("login.mail_recovery.admin_reject")}
          fields={[{ name: "reason", label: t("login.mail_recovery.admin_reason"), type: "textarea", required: true }]}
          onSubmit={async (v) => { await api.post(`/team/2fa-recovery-requests/${r.id}/reject`, v); return t("login.mail_recovery.admin_rejected"); }} />
      </div>
    </li>
  );
}

export function RecoveryRequestsCard() {
  const { t } = useI18n();
  const st = useLoad("/team/2fa-recovery-requests");
  return (
    <Section title={t("login.mail_recovery.admin_title")} testId="recovery-requests">
      <Loadable state={st}>
        {(d) => {
          if (!d.enabled) return <p className="text-sm text-muted-foreground" data-testid="recovery-requests-disabled">{t("login.mail_recovery.admin_disabled")}</p>;
          if (d.requests.length === 0) return <Empty text={t("login.mail_recovery.admin_empty")} testId="recovery-requests-empty" />;
          return <ul className="divide-y divide-border">{d.requests.map((r) => <RequestRow key={r.id} r={r} reload={st.reload} t={t} />)}</ul>;
        }}
      </Loadable>
    </Section>
  );
}
